namespace Matrix.Exceptions {
    export interface ExceptionLinkRow {
        ExceptionLinkId?: number;
        ExceptionSource?: string;
        ExceptionContext?: string;
        ExceptionContextIndex?: number;
        ExceptionKey?: string;
        LinkToSchema?: string;
        LinkToTable?: string;
        LinkToEntityKey?: string;
        LinkToUrl?: string;
        LinkToText?: string;
        ExceptionRowId?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace ExceptionLinkRow {
        export const idProperty = 'ExceptionLinkId';
        export const nameProperty = 'ExceptionSource';
        export const localTextPrefix = 'Exceptions.ExceptionLink';
        export const deletePermission = 'DataAdmin:Exception';
        export const insertPermission = 'DataAdmin:Exception';
        export const readPermission = 'Read:Exception';
        export const updatePermission = 'DataAdmin:Exception';

        export declare const enum Fields {
            ExceptionLinkId = "ExceptionLinkId",
            ExceptionSource = "ExceptionSource",
            ExceptionContext = "ExceptionContext",
            ExceptionContextIndex = "ExceptionContextIndex",
            ExceptionKey = "ExceptionKey",
            LinkToSchema = "LinkToSchema",
            LinkToTable = "LinkToTable",
            LinkToEntityKey = "LinkToEntityKey",
            LinkToUrl = "LinkToUrl",
            LinkToText = "LinkToText",
            ExceptionRowId = "ExceptionRowId",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
